import React from 'react'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'

import '../../styles/dialog.scss'

export default function AlertDialog({
    title,
    content,
    action1,
    action1Disabled = false,
    action1Text,
    action2,
    action2Disabled = false,
    action2Text,
    closeCurrentErrorMessage,
    onClose = null,
    children,
    ...props
}) {
    const [open, setOpen] = React.useState(true)

    const handleClose = () => {
        setOpen(false)
        onClose()
        closeCurrentErrorMessage()
    }

    const handleAction1 = () => {
        setOpen(false)
        action1()
        closeCurrentErrorMessage()
    }

    const handleAction2 = () => {
        setOpen(false)
        action2()
        closeCurrentErrorMessage()
    }

    return (
        <div className="user-alert-container">
            <Dialog
                open={open}
                onClose={onClose ? handleClose : null}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                {...props}
            >
                <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
                <DialogContent>
                    {content && (
                        <DialogContentText id="alert-dialog-description">
                            {content}
                        </DialogContentText>
                    )}
                    {children}
                </DialogContent>
                <DialogActions>
                    {action1Text ? (
                        <Button
                            onClick={handleAction1}
                            color="secondary"
                            disabled={action1Disabled}
                        >
                            <span className="btn">{action1Text}</span>
                        </Button>
                    ) : (
                        ''
                    )}
                    {action2Text ? (
                        <Button
                            onClick={handleAction2}
                            color="secondary"
                            disabled={action2Disabled}
                        >
                            <span className="btn">{action2Text}</span>
                        </Button>
                    ) : (
                        ''
                    )}
                </DialogActions>
            </Dialog>
        </div>
    )
}
